import React, { useState } from "react";
//ESTILOS
import "./Register.css";
//MEDIA
import Info from "../../assets/images/texto_1.png";
import InfoMovil from "../../assets/images/text-movil.png";
import btnInfo from "../../assets/images/boton_standby.png";
import btnInfoH from "../../assets/images/boton_push.png";

function Information({ setRegistrer }) {
  const [btnInfoData, setBtnInfoData] = useState(false);
  return (
    <>
      <div className="grid-nogutter">
        <div className="col-10 col-offset-1">
          <div className="grid">
            <div className="col-12 md:col-7 p-0 informacionT">
              <img src={Info} alt="Información" className="visualEscritorio" />
              <img src={InfoMovil} alt="Información" className="visualMovil" />
              <br />

              <div className="grid mover">
                <div className="col-12">
                  {btnInfoData ? (
                    <img src={btnInfoH} alt="Información" className="imgInfo" />
                  ) : (
                    <img
                      src={btnInfo}
                      alt="Información"
                      className="imgInfo"
                      onClick={() => {
                        setRegistrer(true);
                        setBtnInfoData(true);
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-12 md:col-5 p-0"></div>
            <br />
            <br />
            <br />
          </div>
        </div>
      </div>
    </>
  );
}

export default Information;
